var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"text-white"},[_vm._v(_vm._s(_vm.current_palette_short_description))]),_c('h5',{staticClass:"text-white"},[_vm._v(_vm._s(_vm.current_palette_full_description))])])}
var staticRenderFns = []

export { render, staticRenderFns }